var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "custom-itl__img",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001138",
    fillRule: "evenodd",
    d: "M17.15 6.49a4.34 4.34 0 0 1 4.28 4.27v6.39a4.33 4.33 0 0 1-4.26 4.28h-6.39a4.34 4.34 0 0 1-4.29-4.26v-6.39a4.35 4.35 0 0 1 4.27-4.29Zm0 1.3h-6.37a3 3 0 0 0-3 3v6.36a3 3 0 0 0 3 3h6.36a3 3 0 0 0 3-3v-6.37a3 3 0 0 0-3-2.99ZM14 10a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0 1.29A2.72 2.72 0 1 0 16.68 14 2.72 2.72 0 0 0 14 11.25Zm4-2.17a.91.91 0 1 1 0 1.81.91.91 0 0 1 0-1.81"
  })));
};
export default SvgInstagram;